<template>
  <div class="recipient_question">
    <b-form-group v-if="shouldShowRoleQuestion" label="Role">
      <RoleSelector v-model="recipientRoleId" @input="saveRecipient" />
    </b-form-group>
    <b-form-group v-if="questionFlags.showTitleQuestion" label="Title">
      <b-form-input v-model="title" placeholder="CEO" @focusout="saveRecipient" />
    </b-form-group>
    <b-form-group v-if="shouldShowSeniorityQuestion" label="Seniority">
      <SenioritySelector v-model="seniority" @input="saveRecipient" />
    </b-form-group>
  </div>
</template>

<script lang="ts">
import SenioritySelector from '@/survey/components/SenioritySelector.vue'
import RoleSelector from '@/survey/components/RoleSelector.vue'

export default {
  components: { SenioritySelector, RoleSelector },
  props: {
    recipient: { type: Object, required: false },
    questionFlags: { type: Object, required: true },
    account: { type: Object, required: false },
  },
  data() {
    return {
      recipientRoleId: this.recipient?.recipient_role_id,
      title: this.recipient?.title,
      seniority: this.recipient?.seniority,
    }
  },
  computed: {
    tempHasCoreClassifiersFeature() {
      return this.account?.flipper_features?.includes('core_classifiers')
    },
    shouldShowRoleQuestion() {
      // Hide if core_classifiers feature is enabled, otherwise use questionFlags
      return this.tempHasCoreClassifiersFeature ? false : this.questionFlags.showRoleQuestion
    },
    shouldShowSeniorityQuestion() {
      // Hide if core_classifiers feature is enabled, otherwise use questionFlags
      return this.tempHasCoreClassifiersFeature ? false : this.questionFlags.showSeniorityQuestion
    },
  },
  methods: {
    saveRecipient() {
      const recipient = {
        recipient_role_id: this.recipientRoleId,
        title: this.title,
        seniority: this.seniority,
      }
      this.$emit('recipient-updated', recipient)
    },
  },
}
</script>
